import React from "react";
import EventData from "../components/EventData";

function Event() {
  return (
    <div>
      <EventData />
    </div>
  );
}

export default Event;
